import BlockType102Component from '@headlines/components/block/100-110/block-type-102/BlockType102.vue';
import { AdminBlockType } from '@headlines/types/block/adminBlockType';
import AdminBlockTypeAttributes from '@headlines/config/block/shared/attributes/AdminBlockTypeAttributes';

const AdminBlockType102: AdminBlockType = {
  component: BlockType102Component,
  attributes: AdminBlockTypeAttributes({
    icons: true,
    author: false,
    titleComment: true,
    channel: false,
    category: false,
    lead: false,
    publishDate: false,
    type: 'grid',
    loadMore: false,
  }),
  articlesCount: 30,
};

export default AdminBlockType102;
